export const DOMAN = 'SleepEfficiencyLinkButton';
